// History contains serializable scene data only, never Konva nodes or camera state.
export class EditorHistory {
  constructor(snapshot, { limit = 60, bytes = 20_000_000 } = {}) {
    this.current = snapshot;
    this.past = [];
    this.future = [];
    this.limit = limit;
    this.bytes = bytes;
  }

  record(snapshot) {
    if (snapshot === this.current) return;
    this.past.push(this.current);
    this.current = snapshot;
    this.future = [];
    let size = this.past.reduce((total, entry) => total + entry.length * 2, 0);
    while (this.past.length > this.limit || size > this.bytes) size -= this.past.shift().length * 2;
  }

  undo() {
    if (!this.past.length) return null;
    this.future.push(this.current);
    return (this.current = this.past.pop());
  }

  redo() {
    if (!this.future.length) return null;
    this.past.push(this.current);
    return (this.current = this.future.pop());
  }
}

export function duplicateLayer(scene, id, gridSize, uuid = () => crypto.randomUUID()) {
  const source = scene.shapes.find((shape) => shape.id === id);
  if (!source) return null;
  const rootId = `shape_${uuid()}`;
  const copies = [source, ...scene.shapes.filter((shape) => shape.parentId === id)].map((shape, index) => ({
    ...shape,
    id: index ? `shape_${uuid()}` : rootId,
    parentId: index ? rootId : null,
    x: shape.x + gridSize,
    y: shape.y + gridSize,
    gridColumn: (shape.gridColumn || 0) + 1,
    gridRow: (shape.gridRow || 0) + 1
  }));
  return { scene: { ...scene, shapes: [...scene.shapes, ...copies.slice(1), copies[0]] }, id: rootId };
}
